import { RevenueOpportunitiesSectionState } from 'anchor-scout-common/types';
const KNOWN_SECTION_STATES = Object.values(RevenueOpportunitiesSectionState);
export const unrecognisedStateReport = (state)=>state == null || KNOWN_SECTION_STATES.includes(state) ? null : "revenue-opportunities: unrecognised section state: ".concat(state);
export const sectionView = (param)=>{
    let { isLoading, hasFailed, summary, recognisedCardCount, isHiddenWhileDone } = param;
    if (summary == null && isLoading) {
        return 'loading';
    }
    if (summary == null) {
        return hasFailed ? 'error' : 'nothing';
    }
    if (!KNOWN_SECTION_STATES.includes(summary.state) || summary.state === RevenueOpportunitiesSectionState.Hidden || summary.state === RevenueOpportunitiesSectionState.Active && recognisedCardCount === 0 || summary.state === RevenueOpportunitiesSectionState.Done && isHiddenWhileDone) {
        return 'nothing';
    }
    return summary.state;
};
export const easeOutCubic = (progress)=>1 - (1 - progress) ** 3;
